import React from 'react';
import { remCss } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import { SelectField, View } from '../../basic';
import HospitalSelect from '../../complex/HospitalSelect';
import { generateDurationIntervals } from '../utils';

export const TimeAndLocation = ({
  invalid,
  duration,
  setDuration,
  hospitalParams,
  hospital,
  setHospital
}) => {
  return (
    <div className='mc-modal-body mc-flex-col' style={{ alignItems: 'center', flex: 1 }}>
      <View style={{ width: '100%', maxWidth: remCss(350), gap: remCss(20) }}>
        <SelectField
          template={5}
          isClearable={false}
          options={generateDurationIntervals()}
          name={'duration'}
          invalid={invalid}
          value={duration}
          onChange={(n, v) => setDuration(v)}
        />
        <HospitalSelect
          value={hospital?.hospitalId}
          placeholder={LANG_CONST.location}
          isClearable={true}
          apiConfig={hospitalParams}
          invalid={invalid}
          name={'hospital'}
          onChange={(n, v, o) =>
            !v
              ? setHospital(null)
              : setHospital({
                  hospitalId: v,
                  hospital: o.item.hospital,
                  cityAddress: o.item.city
                })
          }
        />
      </View>
    </div>
  );
};
